import { motion } from "framer-motion";

// Framer Motion scroll-reveal wrapper with graceful reduced-motion handling.
// Use `MotionStagger` on a parent + `MotionStaggerItem` children for grids.
const EASE = [0.22, 1, 0.36, 1];

export const MotionReveal = ({ children, className = "", delay = 0, y = 18, duration = 0.6 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MotionStagger = ({ children, className = "", staggerChildren = 0.09 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    variants={{ hidden: {}, show: { transition: { staggerChildren } } }}
  >
    {children}
  </motion.div>
);

export const MotionStaggerItem = ({ children, className = "", y = 16 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: EASE } },
    }}
  >
    {children}
  </motion.div>
);

export const MotionParallax = ({ children, className = "", strength = 30 }) => (
  <motion.div
    className={className}
    initial={{ y: 0 }}
    whileInView={{ y: -strength }}
    viewport={{ once: false, margin: "0px" }}
    transition={{ duration: 1.2, ease: EASE }}
  >
    {children}
  </motion.div>
);
